module.exports = __webpack_public_path__ + "fe72f58c64c37fabe3069084ea899a9d.mp3";